import React from 'react';
import { Box, CircularProgress, keyframes } from '@mui/material';
const growAnimation = keyframes`
  0% {
    transform: scale(0.8);
    opacity: 0.6;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0.8);
    opacity: 0.6;
  }
`;
const LoadingOverlay = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: 80,
          height: 80,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress
          size={80}
          thickness={4}
          color="primary"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        />
        <Box
          component="img"
          src="/img/LOGO_SINERGISPP.png"
          alt="Loading"
          sx={{
            width: 50,
            height: 50,
            zIndex: 2,
            animation: `${growAnimation} 1.2s ease-in-out infinite`,
          }}
        />
      </Box>

    </Box>
  );
};

export default LoadingOverlay;
